import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { ImportStatusBadge } from "../../../components/dealer/InventoryImportShared";
import { fetchAdminImports } from "../../../services/automapInventoryImportApi";

export default function AdminInventoryImportsListPage() {
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchAdminImports()
      .then((data) => setImports(data.imports || []))
      .catch((err) => setError(err.message || "Error al cargar importaciones."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Inventario"
        title="Importaciones masivas"
        description="Historial de cargas CSV de inventario por concesionario."
      />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <Link className="dealer-portal-btn primary" to="/admin/inventory/imports/new">
            Nueva importación
          </Link>
        </div>

        {error ? <p className="dealer-state-box">{error}</p> : null}
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}

        {!loading && imports.length > 0 ? (
          <table className="dealer-inventory-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Concesionario</th>
                <th>Archivo</th>
                <th>Estado</th>
                <th>Filas</th>
                <th>Creadas</th>
                <th>Actualizadas</th>
                <th>Errores</th>
                <th>Subido por</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {imports.map((item) => (
                <tr key={item.id}>
                  <td>{new Date(item.createdAt).toLocaleString("es-CO")}</td>
                  <td>{item.dealerId?.slice(0, 8)}…</td>
                  <td>{item.sourceFilename}</td>
                  <td>
                    <ImportStatusBadge status={item.status} />
                  </td>
                  <td>{item.totalRows}</td>
                  <td>{item.createdCount}</td>
                  <td>{item.updatedCount}</td>
                  <td>{item.errorCount}</td>
                  <td>{item.uploadedByLabel || "—"}</td>
                  <td>
                    <Link to={`/admin/inventory/imports/${item.id}`}>Detalle</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
